// Update all dependencies next time
/**
 * @param {function(any): void} dispatch
 * @param {Array<any>} elementsActionsArray
 */
export const resetDependenciesContext = (dispatch, ...elementsActionsArray) =>
  elementsActionsArray.forEach((elementsActions) => {
    dispatch(elementsActions.resetContext());
    dispatch(elementsActions.loadList({silent: true}));
  });

// Only refresh if forceLoad is true, if there was already a date, and if there is some data. else, don't.
/**
 * @param {boolean} forceLoad
 * @param {Array<any>} data
 * @returns {boolean}
 */
export const shouldAutoRefreshDependencies = (forceLoad, data) => forceLoad && data.length > 0;
